
import filters from "~/mixins/filters";
import { mapActions, mapGetters } from "vuex";

export default {
	mixins: [filters],
	computed: {
		...mapGetters({
			offer: 'catalog/catalog-cars/offer',
			likesArray: 'favorite/favorite/likesArray',
			settings: 'settings/settings/settings'
		})
	},
	methods: {
		...mapActions({
			liked: 'favorite/favorite/liked',
			openModal: 'modal/modal-main/openModal'
		}),
		async like() {
			await this.liked(this.offer.external_id)
		},
		async callback(carInfo) {
			let payload = {
				modal_data: carInfo,
				modal_component: 'modal-callback',
				modal_title: 'Обратный звонок',
				modal_sub_title: carInfo.name
			}
			await this.openModal(payload)
		},
	}
}
